import { render, staticRenderFns } from "./study-header.vue?vue&type=template&id=179ef859&scoped=true&"
import script from "./study-header.vue?vue&type=script&lang=js&"
export * from "./study-header.vue?vue&type=script&lang=js&"
import style0 from "./study-header.vue?vue&type=style&index=0&id=179ef859&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179ef859",
  null
  
)

component.options.__file = "study-header.vue"
export default component.exports